"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Herbivores = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const TileType_1 = require("../../TileType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const DecreaseAnyProduction_1 = require("../../deferredActions/DecreaseAnyProduction");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Size_1 = require("../render/Size");
class Herbivores extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.HERBIVORES,
            tags: [Tags_1.Tags.ANIMAL],
            cost: 12,
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(8)),
            metadata: {
                cardNumber: '147',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When you place a greenery tile, add an Animal to this card.', (eb) => {
                        eb.greenery(Size_1.Size.MEDIUM, false).startEffect.animals(1);
                    }).br;
                    b.vpText('1 VP per 2 Animals on this card.');
                    b.animals(1).production((pb) => pb.minus().plants(1).any);
                }),
                description: {
                    text: 'Requires 8% oxygen. +1 animal to this card. -1 any plant production',
                    align: 'left',
                },
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.animals(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    canPlay(player) {
        const game = player.game;
        const someoneHasPlantProduction = game.someoneHasResourceProduction(Resources_1.Resources.PLANTS, 1);
        const otherPlayersHavePlantProduction = game.someoneElseHasResourceProduction(player, Resources_1.Resources.PLANTS, 1);
        Card_1.Card.setProductionDecreaseWarningText(this, Resources_1.Resources.PLANTS, otherPlayersHavePlantProduction);
        return super.canPlay(player) && someoneHasPlantProduction;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
    onTilePlaced(cardOwner, activePlayer, space) {
        var _a;
        if (cardOwner.id === activePlayer.id && ((_a = space.tile) === null || _a === void 0 ? void 0 : _a.tileType) === TileType_1.TileType.GREENERY) {
            cardOwner.game.defer(new AddResourcesToCard_1.AddResourcesToCard(cardOwner, ResourceType_1.ResourceType.ANIMAL, { filter: (c) => c.name === this.name }));
        }
    }
    play(player) {
        player.addResourceTo(this, { log: true });
        player.game.defer(new DecreaseAnyProduction_1.DecreaseAnyProduction(player, Resources_1.Resources.PLANTS, 1));
        return undefined;
    }
}
exports.Herbivores = Herbivores;
//# sourceMappingURL=Herbivores.js.map